@if (mapItem(); as mapItem) {
    <ui-detail-view-container>
        <ui-detail-section>
            <ui-detail-image
                [imagePath]="mapItem.imagePath"
                [altText]="mapItem.title"
            />
            <ui-detail-title [title]="mapItem.title"/>
            <ui-detail-address [text]="mapItem.address"/>
            <ui-detail-tags
                [tags]="[
                mapItem.categoryLabel,
                mapItem.transportationTypeLabel,
                statusCode(),
            ]"
            />
        </ui-detail-section>
        @if (mapItem.description || mapItem.shortDescription) {
            <ui-detail-description
                [htmlDescription]="mapItem.description || mapItem.shortDescription"
            />
        }
        @if (mapItem.weblink) {
            <ui-detail-weblink
                [title]="'Website'"
                [link]="mapItem.weblink"
            />
        }
    </ui-detail-view-container>
}
